export default "__VITE_ASSET__DoZjuKpr__"